import React from 'react';
import styled from 'styled-components';
import eyecatch from "@/assets/error-eyecatch.png";

export interface GlobalErrorMessageProps {
    title: string
    titleSub?: string
    contents?: React.ReactNode
}

const GlobalErrorMessage: React.FC<GlobalErrorMessageProps> = (props) => {
    const { title, titleSub, contents } = props

    return (
        <Container>
            <Panel>
                <Image>
                    <img src={eyecatch} alt="error" />
                </Image>
                <Head>{title}</Head>
                {
                    titleSub && <TitleSub>{titleSub}</TitleSub>
                }
                <div>
                    {contents}
                </div>
            </Panel>
        </Container>
    )
}

export default GlobalErrorMessage;

const Container = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: ${p => p.theme.colors.bgMain};

    display: flex;
    flex-direction: column;
    align-items: flex;
    justify-content: center;

    z-index: 99999;
`;


const Panel = styled.div`
    position: fixed;
    left: ${p => p.theme.spaces.large};
    right: ${p => p.theme.spaces.large};

    padding: ${p => p.theme.spaces.section};

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    border-radius: ${p => p.theme.spaces.section};
    background-color: white;
    box-shadow: 6px 6px 10px #aaa;
`;

const Head = styled.h1`
    font-weight: bold;
    font-size: 26px;
`;

const TitleSub = styled.p`
    font-size: 18px;
    margin: 0;
    white-space: pre-wrap;
`;


const Image = styled.div`
    margin: ${p => p.theme.spaces.large};
`